export const CHAT_CHANNEL_TYPES = {
  DIRECT: 1,
  GROUP: 2,
};